import styled from "styled-components";

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;
`;

export const CardGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 64px;
`;

export const CardItem = styled.div`
  & > div {
    margin-bottom: 36px;
    width: fit-content;
  }
  & a {
    height: fit-content;
    width: fit-content;
    display: inline-block;
  }
`;

export const Group = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;

  & > div:first-of-type {
    width: 552px;
    max-width: 100%;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    & > div:first-of-type {
      width: 100%;
    }
  }
`;

export const StatisticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 12px;
  background-color: #f5f5f5;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15),
    0px 1px 2px 0px rgba(0, 0, 0, 0.3);
  min-width: 300px;
`;

export const StatisticsTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
`;

export const StatisticsItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }
`;

export const StatisticsLabel = styled.span`
  font-size: 14px;
  color: #666;
`;

export const StatisticsValue = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #1976d2;
`;

export const CardItemRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const WidgetsRow = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const WidgetCard = styled.div`
  flex: 1;
  min-width: 280px;
  padding: 24px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.1),
    0px 1px 2px 0px rgba(0, 0, 0, 0.2);
`;

export const WidgetTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
`;

export const LimitItem = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const LimitHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 8px;
`;

export const LimitLabel = styled.span`
  font-size: 14px;
  color: #666;
`;

export const LimitValues = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

export const ProgressBarTrack = styled.div`
  width: 100%;
  height: 8px;
  background: #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div<{ percent: number; color?: string }>`
  height: 100%;
  border-radius: 4px;
  transition: width 0.6s ease;
  width: ${({ percent }) => Math.min(percent, 100)}%;
  background: ${({ percent, color }) =>
    color ?? (percent > 90 ? "#d32f2f" : percent > 70 ? "#ed6c02" : "#2e7d32")};
`;

export const QuickActionsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const QuickActionLink = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  background: #f5f5f5;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 14px;
  color: #333;

  &:hover {
    background: #e8e8e8;
  }

  svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
`;

export const StatusDot = styled.span<{ active: boolean }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ active }) => (active ? "#2e7d32" : "#bdbdbd")};
  margin-right: 8px;
`;

export const RouteStatusItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
  color: #333;
`;

export const RouteStatusCount = styled.span`
  font-weight: 600;
  font-size: 16px;
`;
